import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useHomeData } from "../../../lib/useMockData";

export default function StepsSection() {
  const { stepsData } = useHomeData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-14">
              <p className="section-label mb-3">{stepsData.label}</p>
              <h2 className="section-title">{stepsData.title}</h2>
              <p className="section-subtitle">{stepsData.subtitle}</p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {stepsData.steps.map((step, idx) => (
              <ScrollReveal key={step.num} direction="up" delay={idx * 120}>
                <div className="relative text-center">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-airdoa-navy text-airdoa-gold mb-6">
                    <i className={`${step.icon} text-2xl`} />
                  </div>
                  <p className="text-4xl font-serif font-bold text-airdoa-gold/20 absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2">
                    {step.num}
                  </p>
                  <h3 className="text-lg font-serif font-semibold text-airdoa-navy">{step.title}</h3>
                  <p className="mt-3 text-sm text-airdoa-gray leading-relaxed">{step.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal direction="up" delay={300}>
            <div className="mt-12 text-center">
              <Link to={stepsData.cta.href} className="btn-secondary">
                {stepsData.cta.label}
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}